var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"olb-breadcrumb__list-item"},[_c('a',{staticClass:"olb-breadcrumb__list-item-link",class:{
			'olb-breadcrumb__list-item-link--no-url': !_vm.url,
		},attrs:{"href":_vm.url}},[_c('olb-icon',{staticClass:"olb-breadcrumb__list-item-icon",attrs:{"name":"arrow-nav-right"}}),_c('span',{staticClass:"olb-breadcrumb__list-item-title"},[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }